<template>
  <div
    class="product-btn"
    :style="{
      background,
    }"
  >
    <div v-if="icon" :class="`product-btn__icon i-${icon}`"></div>
    <div
      class="product-btn__content"
      :class="{
        'product-btn__content--block': !icon,
      }"
    >
      <div class="product-btn__main">
        <div v-if="title || $slots.title" class="product-btn__main_title">
          <slot name="title">
            {{ title }}
          </slot>
        </div >
        <div>
          <div v-if="isCalculator && (tailTextPaid >= parseInt(tailText) && parseInt(tailText) >= 0  || $slots.tail )" class="product-btn__main_newAmount">
          <slot name="tail">
            {{ $currencyFormatter(tailText )}}
          </slot>
        </div>
        <div v-if="isCalculator && (tailTextPaid > 0 && parseInt(tailText) !=tailTextPaid || $slots.tail)" class="product-btn__main_newAmount_paid">
          <slot name="tail">
              {{ $currencyFormatter( tailTextPaid) }}
          </slot>
        </div>
        <div v-else>
          <div v-if="tailTextPaid!=tailText && tailText || $slots.tail" class="product-btn__main_amount">
          <slot name="tail">
            {{ tailText }}
          </slot>
        </div>
        </div>
      </div>
      </div>
      <div v-if="hint" class="product-btn__hint">
        {{ hint }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductButton",
  props: {
    icon: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    hint: {
      type: String,
      default: "",
    },
    tailText: {
      type: String,
      default: "",
    },
    tailTextPaid: {
      type: Number ,
      default: 0,
    },
    background: {
      type: String,
      default: "white",
    },
    isCalculator:{
      type: Boolean,
      default: false
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.product-btn {
  font-family: "Roboto-Regular";
  display: flex;
  flex-direction: row;
  align-items: center;
  clear: both;
  width: 100vw;
  height: 64px;
  background: $colorWhite;
  color: $colorTextMain;
  padding: 12px 15px 12px 0;
  text-decoration: none;
  position: relative;
  text-align: left;
  z-index: 1;

  &__icon {
    min-width: 20%;
    height: 64px;
    background-repeat: no-repeat;
    background-position: 15px center;
    background-size: 44px auto;
  }

  &__content {
    width: 80%;

    &--block {
      width: 100%;
      padding-left: 15px;
    }
  }

  &__main {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &_title {
      margin-right: 10px;
      //width: calc(100%);
      //white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &_amount {
      flex: 1;
      align-self: center;
      width: min-content;
      color: inherit;
      white-space: nowrap;
      text-align: right;
      padding: 0;
    }
    &_newAmount {
      flex: 1;
      align-self: center;
      width: min-content;
      color: inherit;
      white-space: nowrap;
      text-align: right;
      padding: 0;
      font-weight: 700;
      &_paid {
        color: #a8a8a8;
        text-decoration: line-through;
      }
    }
  }

  &__hint {
    font-size: 12px;
    color: $colorGreyish;
    width: calc(100%);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &.onlineproduct {
      font-size: 14px;
      color: #0089d0;
    }

    &.warning {
      color: $colorRed;
    }
  }
}
</style>
